import { apiService } from '../api';
import type { Pagination } from '../../types';

/** Form links the desk sends families — /api/admission-invites (backend services/admissions/applicationInvites). */

export interface AdmissionInvite {
  _id: string;
  cnic: string;
  fatherCnic: string | null;
  /** Known when the applicant is already on file. */
  name: string | null;
  email: string;
  class: { _id: string; name: string } | null;
  returning: boolean;
  joinsFamily: boolean;
  status: 'sent' | 'submitted' | 'cancelled';
  link: string;
  emailedAt: string | null;
  createdAt: string;
  createdBy: string | null;
}

export interface InviteList {
  items: AdmissionInvite[];
  pagination: Pagination;
  /** Whether the school emails form links (Email setup). */
  emailOn: boolean;
}

export interface CreateInvitePayload {
  cycleId: string;
  cnic: string;
  fatherCnic?: string;
  personId?: string;
  email?: string;
  classId?: string;
}

export const admissionInviteService = {
  list: async (cycleId: string, params: { cnic?: string; page?: number; limit?: number } = {}): Promise<InviteList> =>
    (await apiService.get<InviteList>('/admission-invites', { cycleId, ...params })).data!,

  create: async (payload: CreateInvitePayload): Promise<AdmissionInvite & { emailed: boolean }> =>
    (await apiService.post<AdmissionInvite & { emailed: boolean }>('/admission-invites', payload)).data!,

  /** Email the link again — to a corrected address when one is given. */
  resend: async (id: string, email?: string): Promise<AdmissionInvite> =>
    (await apiService.post<AdmissionInvite>(`/admission-invites/${id}/resend`, email !== undefined ? { email } : {})).data!,

  cancel: async (id: string): Promise<void> => {
    await apiService.delete(`/admission-invites/${id}`);
  },
};
